<template>
  <div class="select-container"
       :class="{
         'filled': isFilled,
         'focused': isFocused,
         'disabled': disabled
       }">
    <span class="placeholder">{{ label }}</span>
    <span class="chevron">
      <b-icon icon="chevron-down" size="is-small"></b-icon>
    </span>
    <select :value="value"
            :disabled="disabled"
            @focus="onFocus"
            @blur="onBlur"
            @change="onChange($event.target.value)">
      <option :value="null" :disabled="required"></option>
      <slot></slot>
    </select>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: null,
        required: false
      },
      label: {
        type: null,
        required: false,
        default: 'Select option'
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      required: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    model: {
      event: 'change'
    },
    data() {
      return {
        isFilled: false,
        isFocused: false
      }
    },
    methods: {
      onFocus() {
        this.isFocused = true
      },
      onBlur() {
        this.isFocused = false
        this.isFilled = this.value
      },
      onChange(val) {
        this.$emit('change', val)
        this.isFilled = this.value
      },
      checkValue() {
        if (this.value) this.isFilled = true
      }
    },
    mounted() {
      this.checkValue()
    },
    watch: {
      value() {
        this.checkValue()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .select-container {
    width: 100%;
    height: 52px;
    position: relative;

    .placeholder {
      position: absolute;
      top: 20px;
      color: #686868;
      z-index: 1;
      font-size: 14px;
      transition: all .2s ease;
    }

    &.disabled .chevron {
      color: #aaa;
    }

    .chevron {
      display: block;
      position: absolute;
      top: 24px;
      right: 0;
    }

    &.filled .placeholder {
      top: 0;
      font-size: 13px;
      color: #afafaf;
    }

    &.focused .placeholder {
      color: #3498db;
    }

    select {
      position: relative;
      z-index: 1;
      background: transparent;
      margin: 18px 0 0 0;
      padding: 6px 20px 8px 0;
      width: 100%;
      border: 0;
      border-bottom: 1px solid #d7dce9;
      transition: border-bottom-color .2s ease;
      font-size: 14px;
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 1px;
      text-overflow: '';
    }

    &.focused input {
      border-color: #3498db;
    }
  }
</style>
